<div class="title">
	<div class="flex-row start">
		<mat-icon svgIcon="brandBlackLogo"></mat-icon>
	</div>
</div>
<ng-content></ng-content>